import { apiService } from '../../shared/services/apiService';
import { EntitySystemInfo } from '../interfaces/EntitySystemInfo';

export const entityInfoService = {
  async getEntitySystemInfoByCoach() {
    const resp = await apiService.get<EntitySystemInfo>('api/coach/entity');

    return resp.data;
  },

  async getEntityAdminInfo() {
    const resp = await apiService.get<{ entities: EntitySystemInfo[] }>(
      'api/admin/entities',
    );

    return resp.data.entities[0];
  },
};
